<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('forms.PopupMassEditPrefs.edit_preferences')"
        class="popup-mass-edit-prefs"
        @closed="$emit('close')"
    >
        <template #default>
            <div class="dialog__default">
                <CompassAlert
                    type="informative"
                    :description="$t.__('forms.PopupMassEditPrefs.onced_saved')"
                    :showIcon="false"
                    :action="{}"
                    :showClose="false"
                />
                <div>
                    <div v-for="(pref, key) in prefsSelected" :key="key">
                        <el-divider v-if="key >= 1"></el-divider>
                        <p class="typographies-paragraph-medium-regular">
                            {{ $l10n.n__('Préférence à mettre à jour') }}
                            <i
                                v-if="prefsSelected.length > 1"
                                class="icon-trash fright gray-60 hover-gray-80"
                                @click="onRemovePref(key, pref)"
                            ></i>
                        </p>
                        <dropdown-search
                            v-model="prefsForDropDown"
                            :pref="pref"
                            class="mb-3"
                            @onMetaSelected="(meta) => onMetaSelected(key, pref, meta)"
                        ></dropdown-search>
                        <pref-mass-edit-input
                            v-if="pref.name"
                            :pref="pref"
                            :metas="metas"
                            :error="errors"
                        ></pref-mass-edit-input>
                    </div>
                    <text-icon
                        v-if="
                            prefsSelected.every((item) => item.name) &&
                            Object.keys(prefsForDropDown).length !== prefsSelected.length
                        "
                        icon="icon-plus"
                        color="primary-50"
                        class="mt-5"
                        @click.native="onAddPref"
                    ></text-icon>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('close')"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    :disabled="!prefsSelected.every((item) => item.name)"
                    class="ml-3"
                    @click="save()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import DropdownSearch from 'vcomponents/inputs/custom/DropdownSearch.vue';
import TextIcon from 'vcomponents/inputs/custom/TextIcon.vue';
import PrefMassEditInput from 'vcomponents/inputs/PrefMassEditInput.vue';
import { checkContainOnlyNumber, checkNotBlank } from './rules/Rules';
import FormMixins from '../../mixins/FormMixins';
import Schema from 'async-validator';

export default {
    components: {
        PrefMassEditInput,
        DropdownSearch,
        TextIcon,
    },
    mixins: [FormMixins],
    props: {
        rows: {
            type: Array,
        },
        emitEditSuccess: {
            type: String,
            required: false,
            default: 'listing:refresh',
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            prefsForDropDown: [],
            prefsSelected: [{}],
            metas: {},
            overlay: null,
        };
    },
    watch: {
        //watch for update label of globaldiscount if currency was modified
        prefsSelected: {
            deep: true,
            handler(newValue) {
                let discountArray;
                if ((discountArray = newValue.find((pref) => pref.name === 'globaldiscount'))) {
                    if (newValue.some((pref) => pref.name === 'currency')) {
                        const currencyArray = newValue.find((pref) => pref.name === 'currency');
                        discountArray.data.options.find((item) => item.value === 'amount').label =
                            currencyArray.data.options.find(
                                (item) => item.value === currencyArray.value,
                            ).label;
                    } else {
                        discountArray.data.options.find((item) => item.value === 'amount').label =
                            '€';
                    }
                }
            },
        },
    },
    created() {
        this.$ajax.get('/rest/meta/preferences', {}, (response) => {
            this.metas = response;
            this.buildPrefsList();
            if (this.type !== 'suppliers') this.buildPrefsListForClientsAndProspects();
        });
    },
    methods: {
        buildPrefsList() {
            this.prefsForDropDown = {
                currency: {
                    name: 'currency',
                    label: this.$l10n.__('Devise'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        options: this.metas.currencies,
                        mode: 'edit',
                        placeholder: this.$l10n.__('Sélectionner une devise'),
                    },
                    value: this.metas.currencies.length > 0 ? this.metas.currencies[0].value : '',
                },
                shippings: {
                    name: 'shippings',
                    label: this.$l10n.__('Transporteur'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        options: this.metas.shippings,
                        mode: 'edit',
                        placeholder: this.$l10n.__('Sélectionner un transporteur'),
                    },
                    value: this.metas.shippings.length > 0 ? this.metas.shippings[0].value : '',
                },
                taxes: {
                    name: 'taxes',
                    label: this.$l10n.__('TVA par défaut'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        options: this.metas.taxes,
                        mode: 'edit',
                        placeholder: this.$l10n.__('Sélectionner une TVA par défaut'),
                    },
                    value: this.metas.taxes.length > 0 ? this.metas.taxes[0].value : '',
                },
                paydates: {
                    name: 'paydates',
                    label: this.$l10n.__('Délai de règlement'),
                    component: 'paydates-select',
                    data: {
                        appendToBody: true,
                        mode: 'edit',
                        placeholder: this.$l10n.__('Sélectionner un délais de règlement'),
                        options: this.metas.paydates,
                    },
                    value: {
                        select: this.metas.paydates.length > 0 ? this.metas.paydates[0].value : '',
                        endMonth: false,
                        payDateXDays: 0,
                    },
                    validator: {
                        paydates: [
                            {
                                validator: (rule, value, callback) => {
                                    if (
                                        value &&
                                        value.payDateXDays === 0 &&
                                        this.paymediumsNumberDayIsSelected(value.select)
                                    )
                                        callback(
                                            new Error(
                                                this.$l10n.__(
                                                    'Le nombre de jours doit être supérieur à 0',
                                                ),
                                            ),
                                        );
                                    else callback();
                                },
                            },
                        ],
                    },
                },
                globaldiscount: {
                    name: 'globaldiscount',
                    label: this.$l10n.__('Réduction globale'),
                    component: 'input-with-select',
                    data: {
                        placeholder: this.$l10n.__('Saisir une réduction globale'),
                        options: this.metas.discountUnits,
                    },
                    value: {
                        input: '',
                        select: 'amount',
                    },
                    validator: {
                        globaldiscount: [
                            { validator: checkNotBlank },
                            { validator: checkContainOnlyNumber },
                        ],
                    },
                },
                paymediums: {
                    name: 'paymediums',
                    label: this.$l10n.__('Moyen de règlement'),
                    component: 'el-cascader',
                    data: {
                        props: { multiple: true },
                        options: this.metas.paymediums,
                        placeholder: this.$l10n.__('Sélectionner un moyen de règlement'),
                    },
                    value: [],
                    validator: {
                        paymediums: [
                            {
                                validator: (rule, value, callback) => {
                                    if (value && value.length === 0)
                                        callback(
                                            new Error(
                                                this.$l10n.__(
                                                    'Vous devez sélectionner au moins une valeur',
                                                ),
                                            ),
                                        );
                                    else callback();
                                },
                            },
                        ],
                    },
                },
                bankAccounts: {
                    name: 'bankAccounts',
                    label: this.$l10n.__('Compte bancaire'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        mode: 'edit',
                        placeholder: this.$l10n.__('Sélectionner un compte bancaire'),
                        options: this.metas.bankAccounts,
                    },
                    value:
                        this.metas.bankAccounts.length > 0 ? this.metas.bankAccounts[0].value : '',
                },
                discountByRows: {
                    name: 'discountByRows',
                    label: this.$l10n.__('Remise par ligne'),
                    component: 'el-checkbox',
                    data: {
                        mode: 'edit',
                        label: this.$l10n.__('Appliquer la remise sur chaque ligne'),
                        'true-label': 'Y',
                        'false-label': 'N',
                    },
                    value: 'N',
                },
            };
        },
        buildPrefsListForClientsAndProspects() {
            this.prefsForDropDown = {
                ...this.prefsForDropDown,
                rateCategories: {
                    name: 'rateCategories',
                    label: this.$l10n.__('Catégorie tarifaire'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        mode: 'edit',
                        placeholder: this.$l10n.__('Sélectionner une catégorie tarifaire'),
                        options: this.metas.rateCategories,
                    },
                    value:
                        this.metas.rateCategories.length > 0
                            ? this.metas.rateCategories[0].value
                            : '',
                },
                dunningEstimates: {
                    name: 'dunningEstimates',
                    label: this.$l10n.__('Relance automatique - Plan devis'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        mode: 'edit',
                        placeholder: this.$l10n.__(
                            'Sélectionner une relance automatique pour les devis',
                        ),
                        options: this.metas.dunningEstimates,
                    },
                    value:
                        this.metas.dunningEstimates.length > 0
                            ? this.metas.dunningEstimates[0].value
                            : '',
                },
                dunningInvoices: {
                    name: 'dunningInvoices',
                    label: this.$l10n.__('Relance automatique - Plan facture'),
                    component: 'select-input',
                    data: {
                        appendToBody: true,
                        mode: 'edit',
                        placeholder: this.$l10n.__(
                            'Sélectionner une relance automatique pour les factures',
                        ),
                        options: this.metas.dunningInvoices,
                    },
                    value:
                        this.metas.dunningInvoices.length > 0
                            ? this.metas.dunningInvoices[0].value
                            : '',
                },
            };
        },
        onMetaSelected(key, oldPref, meta) {
            if (oldPref.name && oldPref.name !== meta.name) {
                this.prefsForDropDown[oldPref.name].isSelected = false;
            }
            this.prefsSelected.splice(key, 1, _.cloneDeep(meta));
            this.prefsForDropDown[meta.name].isSelected = true;
        },
        onAddPref() {
            this.prefsSelected.push({});
        },
        save: function () {
            const payload = [];
            if (this.validateInput()) {
                this.populatePayload(payload);
                const thirdIdsParsed = [];
                this.rows.forEach((row) => {
                    row = row.replace('third_', '');
                    row = parseInt(row, 10);
                    thirdIdsParsed.push(row);
                });
                payload['thirdIds'] = thirdIdsParsed;

                this.$ajax.put(
                    '/rest/thirds/batch/preferences',
                    {},
                    _.toPlainObject(payload),
                    () => {
                        EventBus.emit(this.emitEditSuccess);
                        this.$emit('close');
                        Push.success(this.$l10n.__('Modification effectuée.'));
                    },
                    () => {
                        Push.error(
                            this.$l10n.__(
                                'Une erreur est survenue lors de la mise à jour des préférences.',
                            ),
                        );
                    },
                );
            }
        },
        validateInput() {
            let isValide = true;
            this.prefsSelected.forEach((item) => {
                if (item.validator) {
                    const validator = new Schema(item.validator);
                    validator.validate(
                        {
                            globaldiscount: item.value.input,
                            paydates: item.value,
                            paymediums: item.value,
                        },
                        (errors) => {
                            if (errors) {
                                isValide = false;
                                this.errors.setOneError(item.name, errors[0].message);
                            } else {
                                this.errors.clear(item.name);
                            }
                        },
                    );
                }
            });
            return isValide;
        },
        populatePayload(payload) {
            this.prefsSelected.forEach((item) => {
                if (item.value === '' || !item.value || item.value.length === 0) return;
                switch (item.name) {
                    case 'currency':
                        payload['currencyId'] = item.value;
                        break;
                    case 'shippings':
                        payload['shippingId'] = item.value;
                        break;
                    case 'globaldiscount':
                        payload['globalDiscount'] = item.value.input;
                        payload['globalDiscountUnit'] = item.value.select;
                        break;
                    case 'paydates':
                        payload['payDateId'] = item.value.select;
                        payload['payDateEndMonth'] = item.value.endMonth;
                        if (this.paymediumsNumberDayIsSelected(item.value.select)) {
                            payload['payDateXDays'] = item.value.payDateXDays;
                        }
                        break;
                    case 'taxes':
                        payload['taxId'] = item.value;
                        break;
                    case 'paymediums':
                        payload['payMediumIds'] = _.flatten(item.value);
                        break;
                    case 'rateCategories':
                        payload['rateCategoryId'] = item.value;
                        break;
                    case 'bankAccounts':
                        payload['bankAccountId'] = item.value;
                        break;
                    case 'dunningEstimates':
                        payload['dunningEstimateId'] = item.value;
                        break;
                    case 'dunningInvoices':
                        payload['dunningInvoiceId'] = item.value;
                        break;
                    case 'discountByRows':
                        payload['discountByRows'] = item.value;
                        break;
                    case undefined:
                    default:
                        break;
                }
            });
        },
        onRemovePref(key, command) {
            if (command.name) this.prefsForDropDown[command.name].isSelected = false;
            this.prefsSelected.splice(key, 1);
        },
        // if value "saisir un nombre de jours" => id 42 for paydates is selected we return true
        paymediumsNumberDayIsSelected(id) {
            const paydatesWithNumberOfDays = this.metas.paydates.filter((paydate) => {
                return paydate.value === id;
            });
            return (
                paydatesWithNumberOfDays.length > 0 &&
                paydatesWithNumberOfDays[0].syscode === 'xdays'
            );
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.popup-mass-edit-prefs {
    p {
        margin: 0 0 var(--spacing-0);
    }
    div > p > i {
        cursor: pointer;
    }

    .dialog {
        &__header {
            display: flex;
            justify-content: space-between;
            padding: var(--spacing-4) var(--spacing-5);

            &--title {
                display: flex;
                flex-direction: column;
            }

            &--close {
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }

        &__default {
            padding-bottom: var(--spacing-4);
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 var(--spacing-5) var(--spacing-4);
        }
    }

    .el-dialog__wrapper .el-dialog.flex-column {
        max-height: 800px;
        border-radius: 4px;

        .el-dialog__header {
            padding-bottom: var(--spacing-4);

            button i {
                color: $gray-100;
            }
        }
    }
}
</style>
